import { useTranslation } from 'react-i18next';

const Loading = () => {
    const { t } = useTranslation('shared');
    return (
        <div className="full__size">
            {t('LOADING')}
        </div>
    );
};

export default Loading;
